export const clamp = (value: number, min: number, max: number): number =>
  value < min ? min : value > max ? max : value;

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

/** Where `value` sits between `a` and `b`, clamped to [0, 1]. */
export const invLerp = (a: number, b: number, value: number): number =>
  a === b ? 0 : clamp((value - a) / (b - a), 0, 1);

export const easeOutCubic = (t: number): number => 1 - Math.pow(1 - t, 3);
export const easeInQuad = (t: number): number => t * t;
export const easeInOutSine = (t: number): number => -(Math.cos(Math.PI * t) - 1) / 2;
export const easeOutBack = (t: number): number => {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
};

/** Round money to cents without floating point drift in displays. */
export const roundCents = (value: number): number => Math.round(value * 100) / 100;

export const formatMoney = (value: number): string =>
  `$${roundCents(value)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

export const formatViews = (views: number): string => {
  if (views >= 1_000_000) return `${(views / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  if (views >= 1_000) return `${(views / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
  return `${Math.round(views)}`;
};
